// assets/vh-v2.js — WP-P16a: Sheet-Logik der V2-Test-PDP (mammaly-Muster), ES5, kein Framework.
// Geladen aus sections/vh-v2-hero.liquid NACH assets/vh-pdp.js (Brief §1: "wird ... nach vh-pdp.js
// geladen"). vh-pdp.js bleibt unveraendert (Galerie/Waehler/Produktformular laufen weiter darueber);
// diese Datei deckt nur das ab, was V1 nicht kennt: die beiden Bottom-Sheets (#vh-paket, #vh-v2-info)
// und ihre mobilen Einstiege (Sticky-Leiste aus vh-v2-sticky.liquid, "Mehr erfahren", der bestehende
// #vh-kaufen-Anker aus sections/vh-abschluss-cta.liquid — Datei unveraendert, Attribut a[href="#vh-kaufen"]
// bzw. [data-scroll-kaufen] existiert dort bereits).
//
// Brief §5 Zeile 2: "Nur unter 900 px aktiv ...; bei Wechsel auf Desktop alle Sheets schliessen."
// Dokumentierte Auslegung (s. Protokoll, offene Frage 1): das Paket-Sheet (#vh-paket) ist auf
// Desktop per CSS bereits inline sichtbar (vh-v2.css) und hat dort KEINEN sichtbaren Oeffnen-Trigger
// mehr (Sticky-Leiste ist ab 900px per CSS ausgeblendet) - fuer #vh-paket ist "nur mobil aktiv" also
// bereits durch die Trigger-Sichtbarkeit + den expliziten Guard unten sichergestellt. Der Button
// "Mehr erfahren" (Info-Sheet) bleibt dagegen laut Brief §3 Punkt 3 bei JEDER Breite sichtbar - eine
// Blockade des Oeffnens ab 900px waere ein totes UI-Element ohne jede Funktion. Deshalb: das
// Oeffnen/Schliessen-Grundgeruest ist breitenunabhaengig funktionsfaehig (Info-Sheet bleibt bei jeder
// Breite ein echtes Overlay, Brief nennt fuer es keine Desktop-Sonderrolle); "nur unter 900px aktiv"
// wird konkret umgesetzt als (a) Reset-auf-Desktop-Wechsel (unten, wortgleich zum Brief) und (b) ein
// expliziter Guard, der das JS-Oeffnen von #vh-paket ab 900px verhindert (dort uebernimmt CSS die
// Sichtbarkeit). Wisch-Geste ist ohnehin nur mit Touch-Events erreichbar und damit auf Desktop-
// Zeigegeraeten faktisch inaktiv, ganz ohne Breiten-Abfrage.
(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var mqMobile = window.matchMedia('(max-width: 899px)');
  var html = document.documentElement;
  var lastTrigger = null;

  function anyOpen() {
    return $$('.vh-sheet').some(function (s) { return !s.hidden; });
  }

  // r21b: Body-Scroll-Lock fuer iOS (html{overflow:hidden} greift dort nicht: die Seite hinter dem Sheet scrollt mit, die
  // Toolbar klappt ein/aus und das bottom:0-Panel loest sich vom Rand — Inhaber 22.09.: Kopf abgeschnitten, durchsichtiger
  // Streifen unter PayPal). Nur unter 900 px; Scrollposition wird beim Schliessen wiederhergestellt.
  var lockY = null;
  function lockBody() {
    if (lockY !== null || !mqMobile.matches) return;
    lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed'; b.style.top = (-lockY) + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
  }
  function unlockBody() {
    if (lockY === null) return;
    var b = document.body, y = lockY; lockY = null;
    b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
    window.scrollTo(0, y);
  }

  function openSheet(id, trigger) {
    var sheet = document.getElementById(id);
    if (!sheet || !sheet.classList.contains('vh-sheet')) return;
    sheet.hidden = false;
    html.classList.add('vh-sheet-open');
    lockBody();
    lastTrigger = trigger || null;
    var closeBtn = $('.vh-sheet__close', sheet);
    if (closeBtn) closeBtn.focus();
  }

  function closeSheet(sheet) {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    var panel = $('.vh-sheet__panel', sheet);
    if (panel) panel.style.transform = '';
    if (!anyOpen()) { html.classList.remove('vh-sheet-open'); unlockBody(); }
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  function closeAll() {
    $$('.vh-sheet').forEach(function (s) { s.hidden = true; });
    html.classList.remove('vh-sheet-open');
    unlockBody();
  }

  // === OEFFNEN / SCHLIESSEN ===
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-sheet-open]');
    if (openBtn) { openSheet(openBtn.getAttribute('data-sheet-open'), openBtn); return; }

    var closeEl = e.target.closest('[data-sheet-close]');
    if (closeEl) {
      // Kein preventDefault: der Info-Sheet-Link "Alle Details" ist ein a[href="#shopify-section-produkttext"]
      // und braucht den nativen Anker-Sprung zusaetzlich zum Schliessen (Brief §3 Punkt 7).
      var sheet = closeEl.closest('.vh-sheet');
      if (sheet) closeSheet(sheet);
      return;
    }

    // Abschluss-CTA aus vh-abschluss-cta.liquid (unveraendert) verlinkt/scrollt auf #vh-kaufen.
    var kaufAnchor = e.target.closest('a[href="#vh-kaufen"], [data-scroll-kaufen]');
    if (kaufAnchor) {
      e.preventDefault();
      openSheet('vh-paket', kaufAnchor);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      $$('.vh-sheet').forEach(function (s) { if (!s.hidden) closeSheet(s); });
    }
  });

  // Wischen nach unten am Griff (ab 80px Weg) — touchstart/touchmove/touchend, mit optischem
  // Mitziehen des Panels waehrend der Geste (kein Timer, keine Endlosschleife: reine Eventfolge).
  $$('.vh-sheet__griff').forEach(function (griff) {
    var sheet = griff.closest('.vh-sheet');
    var panel = sheet ? $('.vh-sheet__panel', sheet) : null;
    var y0 = null;
    griff.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
    griff.addEventListener('touchmove', function (e) {
      if (y0 === null || !panel) return;
      var dy = e.touches[0].clientY - y0;
      if (dy > 0) panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    griff.addEventListener('touchend', function (e) {
      if (y0 === null) return;
      var dy = e.changedTouches[0].clientY - y0;
      y0 = null;
      if (dy > 80 && sheet) { closeSheet(sheet); return; }
      if (panel) panel.style.transform = '';
    }, { passive: true });
  });

  // r16: Sheets sind auf jeder Breite eine Ebene (Desktop: zentrierte Karte per CSS) — kein Reset bei Breitenwechsel.
  // Sticky-Leiste erst, wenn der Inline-Button „Paket wählen" nach oben aus dem Bild gescrollt ist (mammaly-Muster).
  // r17: Scroll-Pruefung statt IntersectionObserver — der Observer feuert bei Spruengen (Anker, scrollTo) nicht,
  // wenn der Block nie im Viewport war. Sichtbar, sobald der Inline-Block komplett nach oben aus dem Bild ist.
  var ctaBlock = $('[data-v2-cta]'), stickyBar = $('.vh-v2-sticky'), stickyTick = false;
  function updateSticky() { stickyTick = false; if (!ctaBlock || !stickyBar) return; stickyBar.classList.toggle('is-visible', ctaBlock.getBoundingClientRect().bottom < 0); }
  if (ctaBlock && stickyBar) {
    window.addEventListener('scroll', function () { if (!stickyTick) { stickyTick = true; window.requestAnimationFrame(updateSticky); } }, { passive: true });
    window.addEventListener('resize', function () { if (!stickyTick) { stickyTick = true; window.requestAnimationFrame(updateSticky); } });
    updateSticky();
  }

  // Nach add-to-cart (vh-pdp.js oeffnet danach die Warenkorb-Seitenleiste): Paket-Sheet schliessen.
  var pf = $('#vh-paket [data-js-product-form]');
  // r14 (Hauptmodell): vh-pdp.js haengt seinen Seitenleisten-Oeffner nur an '.vh-buybox [data-js-product-form]' (V1-Wrapper),
  // den V2 nicht hat -> hier Sheet schliessen UND Seitenleiste oeffnen (1:1 nach section-main-product.js Z. 96-107).
  if (pf) pf.addEventListener('add-to-cart', function () {
    var paket = document.getElementById('vh-paket');
    if (paket) closeSheet(paket);
    var sb = document.getElementById('site-cart-sidebar'); if (sb && typeof sb.show === 'function') sb.show();
    var cr = document.getElementById('cart-recommendations'); if (cr && typeof cr.generateRecommendations === 'function') cr.generateRecommendations();
  });

  // r21: Sticky-Leiste zeigt die aktuelle Auswahl (Menge × Groesse, Streich-/Endpreis) statt „ab <Variantenpreis>"
  // (Inhaber 22.09.: „ab 99,90 € ist falsch, bei hoeherer Menge ist es billiger"). Quelle: vh:variantchange aus vh-pdp.js render().
  var stWahl = $('[data-v2-sticky-wahl]'), stPrice = $('[data-v2-sticky-price]'), stCmp = $('[data-v2-sticky-compare]');
  document.addEventListener('vh:variantchange', function (e) {
    var d = e.detail || {};
    if (stWahl && d.groesse) stWahl.textContent = (d.qty || 1) + ' × ' + d.groesse + (d.abo ? ' · Abo' : '');
    if (stPrice && d.price) stPrice.textContent = d.available === false ? 'Ausverkauft' : d.price;
    if (stCmp) { var sc = !!d.compare && d.available !== false; stCmp.hidden = !sc; if (sc) stCmp.textContent = d.compare; }
  });

  // r21: sanftes Scrollen fuer Seiten-Anker (z. B. „Alle Unterschiede im Vergleich" -> #vh-vergleich).
  // #vh-kaufen oeffnet weiter das Sheet (Handler oben), data-sheet-close-Links behalten den nativen Sprung.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#vh-"]');
    if (!a || a.getAttribute('href') === '#vh-kaufen' || a.hasAttribute('data-sheet-close')) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history && history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
  });
})();
